import { Component, OnInit } from '@angular/core';

import {RootScopeService} from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { CommonUtil } from '../../core/Utils/common-util';
import { ActivatedRoute, Router } from '@angular/router';
import { GetFacilityInfoByEmailService } from '../services/get-facility-info-by-email.service';
import { FacilityMaintainanceUserDetailsObject, FacilitySummaryObject } from '../../core/services/facility.model';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {

  rootScopeData: RootScopeDeclare;
  displayStep: number;
  step1Info: FacilityMaintainanceUserDetailsObject | null;
  step2Info: FacilitySummaryObject;
 // step1UserDetails: any;
  managerParam: string | null;
  showModal = false;


  constructor(private rootScopeService: RootScopeService, public commonUtil:CommonUtil,
              private route: ActivatedRoute, private getFacilityInfo:GetFacilityInfoByEmailService,
              private router: Router,
              private _amplitudeAnalytics: AmplitudeAnalyticsService) {
    this.getRootScopeData();
    this.rootScopeData.pageName='Signup';
  }

  ngOnInit() {
    this.managerParam= this.route.snapshot.queryParamMap.get('token');
    if(this.managerParam){
      localStorage.setItem('splashVisited', 'true');
      this.getFacilityInfo.getFacilityInformationByEmail(this.managerParam)
      .subscribe(
        data => {
          this.step2Info = data.facility;
          this.step1Info = data.user;
          this.showStep1();
        },
        error => {
          this.managerParam = null;
          this.showStep1();
          console.error('API error.');
        }
      );
    }
    else{
      this.showStep1();
    }
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  scrollToStepper(): void {
    const elmnt = <HTMLElement>document.getElementById("stepper-cntr");
    elmnt.scrollIntoView({behavior: 'smooth'});
  }

  showStep1() {
    this.displayStep = 1;
    this.scrollToStepper();
  }

  showStep2() {
    this.displayStep = 2;
    this.scrollToStepper();
  }

  showStep3() {
    this.displayStep = 3;
    this.scrollToStepper();
  }

  step1DataHandler(step1Data: FacilityMaintainanceUserDetailsObject): void {
    this.step1Info = step1Data;
   }

  step2DataHandler(step2Data: FacilitySummaryObject): void {
    this.step2Info = step2Data;
  }

  cancelSignUpHandler():void{
    this.openModal();
    return;
  }

  openModal(): void {
    this.showModal = true;
  }

  onPositiveConfirmation(): void {
    this.closeModal();
    this._amplitudeAnalytics.logEvent({elementName: 'Cancel', action: "Click"});
    this.router.navigate(['/landing']);
  }

  closeModal(): void {
    this.showModal = false;
  }

}
